import { useState } from 'react';
import { navItemType } from '@cx-web/domain-types';

import { useLayoutStore } from '~/providers/layout-store-provider';

import Accordion from '../Accordion';

import styles from './SportsList.module.css';

export const SportsList = () => {
  const allLinks = useLayoutStore(
    s => s.navData.mobileBottomNav.find(item => item.type === navItemType.ALL_SPORTS_EXPANDABLE)?.items?.allLinks || [],
  );

  const [activeAccordion, setActiveAccordion] = useState('');

  return (
    <div aria-label="Sport Categories" className={styles.sportsList}>
      {allLinks.map((sport, index) => (
        <Accordion
          headerIcon={sport.icon}
          headerLink={sport.link || ''}
          headerName={sport.name}
          isActiveAccordion={activeAccordion === sport.name}
          key={index}
          setActiveAccordion={sportName => setActiveAccordion(sportName)}
          subLinks={sport.subLinks}
        />
      ))}
    </div>
  );
};
